import { bl_hr_org_chart_hierarchy_node_hdr_RowClass } from '../../dbschema/bl_hr_org_chart_hierarchy_node_hdr.model';
import { BaseContainerModel } from '../base-container.model';


export class OrgChartHierarchyNodeHdrContainerModel extends BaseContainerModel {
    bl_hr_org_chart_hierarchy_node_hdr: bl_hr_org_chart_hierarchy_node_hdr_RowClass = new bl_hr_org_chart_hierarchy_node_hdr_RowClass();
}